export const Reti = {
    ETHEREUM: 'ethereum',
    BINANCE: 'binance'
};

export const Wallets = {
    METAMASK: 'metamask',
    COINBASE: 'coinbase'
}